export default __webpack_public_path__ + "static/media/room.5d35985c.svg";